import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import toolActions from '../../redux/futures/tools/actions';
import * as types from '../../redux/futures/tools/types';
import Input from '../../components/Input';
import ConfirmModal from '../../components/ConfirmModal';

class ImportWebsite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromEmail: '',
            toEmail: '',
            file: null,
            loading: false,
            classNormal: 'ladiui button primary',
            classLoading: 'ladiui loader button primary',
            classApply: 'ladiui button primary',
        };
        this.inputsRef = new Set();
        this.ref = React.createRef();
    }

    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps && nextProps.action === types.IMPORT_WEBSITE) {
            this.setState({
                loading: false,
                classApply: this.state.classNormal,
            });
            window.LadiUI.closeModalById('confirm-import-website');
            if (nextProps.status) {
                window.LadiUI.toastr('success', '', nextProps.message);
                const self = this;
                setTimeout(() => {
                    window.LadiUI.closeModal(self.ref.current);
                }, 1000);
                this.resetFormState();
            } else {
                window.LadiUI.toastr('error', '', nextProps.message);
            }
        }
    }

    resetFormState = () => {
        this.setState({
            fromEmail: '',
            toEmail: '',
            file: null,
        });
        if (this.fileInputRef) {
            this.fileInputRef.value = '';
        }
    };

    onChangeInput = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    onFileChange = (event) => {
        const file = event.target.files && event.target.files[0];
        this.setState({ file: file || null });
    };

    submit = () => {
        const errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, (ref) => {
            if (ref && ref.validate) {
                errors.push(...ref.validate());
            }
        });
        if (errors.length > 0) {
            window.LadiUI.toastr('error', '', errors.join('<br/>'));
            return;
        }
        const { file } = this.state;
        if (!file) {
            window.LadiUI.toastr('error', '', 'Vui lòng chọn file');
            return;
        }
        window.LadiUI.showModalById('confirm-import-website');
    };

    doSubmit = () => {
        const { fromEmail, toEmail, file } = this.state;
        const formdata = new FormData();
        formdata.append('from_email', fromEmail);
        formdata.append('to_email', toEmail);
        formdata.append('file', file);
        this.props.importWebsite(formdata);
        this.setState({
            loading: true,
            classApply: this.state.classLoading,
        });
    };

    resetForm = (event) => {
        if (!event.target.hasAttribute('data-dismiss')) {
            return;
        }
        this.resetFormState();
        window.LadiUI.closeModal(this.ref.current);
    };

    render() {
        const { fromEmail, toEmail, loading, classApply } = this.state;

        return (
            <>
                <div
                    ref={this.ref}
                    id="modal-import-website"
                    className="ladiui-modal fade"
                    tabIndex={-1}
                    data-dismiss="modal-import-website"
                    onClick={this.resetForm}
                >
                    <div className="ladiui-modal-content">
                        <div className="ladiui-modal-header">
                            <button type="button" className="ladiui-close-modal" data-dismiss="modal-import-website">
                                <i className="ladi-icon icon-e-remove" data-dismiss="modal-import-website" />
                            </button>
                            <h3>Import website</h3>
                        </div>
                        <div className="ladiui-modal-body">
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div className="ladiui-tab-content">
                                    <div className="ladiui-row">
                                        <div className="col-50">
                                            <div className="ladiui form-group">
                                                <label className="ladiui-label">From email</label>
                                                <Input
                                                    ref={(ref) => ref && this.inputsRef.add(ref)}
                                                    name="fromEmail"
                                                    validationName="From email"
                                                    placeholder="From email"
                                                    value={fromEmail}
                                                    onChange={this.onChangeInput}
                                                    validations={{ isRequired: true, email: true }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-50">
                                            <div className="ladiui form-group">
                                                <label className="ladiui-label">To email</label>
                                                <Input
                                                    ref={(ref) => ref && this.inputsRef.add(ref)}
                                                    name="toEmail"
                                                    validationName="To email"
                                                    placeholder="To email"
                                                    value={toEmail}
                                                    onChange={this.onChangeInput}
                                                    validations={{ isRequired: true, email: true }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ladiui-row">
                                        <div className="col-100">
                                            <div className="ladiui form-group">
                                                <label className="ladiui-label" htmlFor="file-input-website">File</label>
                                                <input
                                                    id="file-input-website"
                                                    ref={(el) => (this.fileInputRef = el)}
                                                    type="file"
                                                    name="file-input-website"
                                                    className="ladiui input"
                                                    onChange={this.onFileChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="ladiui-modal-footer">
                            <button className="ladiui button secondary close-modal icon" data-dismiss="modal-import-website">
                                <i className="ladi-icon icon-e-remove" data-dismiss="modal-import-website" />Đóng
                            </button>
                            <button
                                className={classApply}
                                onClick={this.submit}
                                disabled={loading}
                            >
                                <i className="ladi-icon icon-floppy-disk" style={{ display: loading ? 'none' : '', paddingRight: '5px' }} />
                                Gửi
                            </button>
                        </div>
                    </div>
                </div>
                <ConfirmModal
                    id="confirm-import-website"
                    title="Xác nhận import website"
                    content="Bạn có chắc chắn muốn gửi?"
                    cancelText="Huỷ bỏ"
                    okText="Đồng ý"
                    onOk={this.doSubmit}
                    isLoading={loading}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({ ...state.tool });

const mapDispatchToProps = (dispatch) => ({
    importWebsite: (formdata) => dispatch(toolActions.importWebsite(formdata)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportWebsite);
